import { type SubmitFunction } from '@remix-run/react'
import { JSON_FORM } from '#app/constants/forms.ts'
import { type GetNextQuestionIdAndAnswerParams } from '#types/form/wizard.ts'
import { type GlobalFormStore } from '../../reducer/createGlobalFormStore.ts'
import { handleCompletedForm } from '../../utils/handleCompletedForm.ts'

interface HandleOnSubmit<T> {
	type: string
	HandleJSONState: Function
	resetField: Function
	submit: SubmitFunction
	currentStepProps: any
	useGlobalFormStore: GlobalFormStore<T>
	CSRFToken: string
	actionRoute: string
	handleRegularState: Function
	dispatch: Function
	currentFormContext: GetNextQuestionIdAndAnswerParams
	formHasBeenCompleted: boolean
}

export function onSubmitCaller<T>({
	type,
	HandleJSONState,
	resetField,
	submit,
	actionRoute,
	currentStepProps,
	useGlobalFormStore,
	CSRFToken,
	handleRegularState,
	dispatch,
	currentFormContext,
	formHasBeenCompleted,
}: HandleOnSubmit<T>) {
	if (formHasBeenCompleted) {
		return handleCompletedForm({
			CSRFToken,
			submit,
		})
	}

	if (type === JSON_FORM) {
		HandleJSONState({
			resetField,
			submit,
			currentStepProps,
			actionRoute,
			entireGlobalState: useGlobalFormStore,
			useGlobalFormStore,
			CSRFToken,
			currentFormContext,
			formHasBeenCompleted,
		})
	} else {
		handleRegularState({
			CSRFToken,
			actionRoute,
			currentFormContext,
			currentStepProps,
			dispatch,
			submit,
			useGlobalFormStore,
			formHasBeenCompleted,
		})
	}
}
